<template>
  <div class="reminders">
    <v-card class="letter-card">
      <v-row>
        <v-col>
          <h4>یادآوری پیگیری</h4>
        </v-col>
        <v-col class="pe-2">
          <div class="custom-input">
            <v-text-field
              class="float-end"
              outlined
              dense
              style="width: 330px"
              v-model="search"
              placeholder="شماره نامه را جستجو کنید..."
            >
              <template #prepend-inner>
                <v-icon> $Magnify </v-icon>
              </template>
              <template v-if="search.length" #append>
                <v-icon @click="search = ''"> $Close </v-icon>
              </template>
            </v-text-field>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="custom-vselect pt-1 d-flex flex-row">
            <span class="ps-3">نوع نامه</span>
            <v-select
              outlined
              dense
              :items="typeOptions"
              v-model="letterType"
              @change="currentPage = 1"
            ></v-select>
          </div>
        </v-col>
      </v-row>
      <v-card class="text-center" v-if="!isLoaded">
        <cube></cube>
        <span style="font-size: 16px">در حال بارگذاری ...</span>
      </v-card>
      <div v-else>
        <v-card class="mt-4 ps-0 pe-0" v-if="search && !filteredLetters.length">
          <v-row>
            <v-col
              class="text-center text--grey text--darken-1"
              style="font-size: 15px"
            >
              <div class="border-box">
                <v-icon style="margin-left: 88px">$NoResult</v-icon>
                <p style="margin-top: 88px" class="mb-0">
                  نتیجه‌ای برای "{{ search }}" یافت نشد.
                </p>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <v-card
          class="mt-4 ps-0 pe-0"
          v-if="!search && !filteredLetters.length"
        >
          <v-row>
            <v-col
              class="text-center text--grey text--darken-1"
              style="font-size: 16px"
            >
              <div class="border-box">
                <v-icon style="margin-left: 88px">$NoLetter</v-icon>
                <p style="margin-top: 88px">نامه‌ای برای نمایش وجود ندارد.</p>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <div v-if="filteredLetters.length" class="custom-table mt-8">
          <b-table
            responsive
            show-empty
            stacked="sm"
            :current-page="currentPage"
            :per-page="perPage"
            :items="filteredLetters"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="نامه‌ای برای نمایش وجود ندارد"
            striped
            thead-class="headClass"
            tbody-class="bodyClass"
            :busy="isBusy"
          >
            <template v-slot:cell(index)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-lg-3 pt-0"
              >
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-lg-3 pt-0"
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(type)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-lg-2 pt-0"
              >
                <div
                  class="mx-auto ps-6 pe-6"
                  :class="
                    data.value == 'ورودی'
                      ? 'purple-badge'
                      : data.value == 'سازمانی'
                      ? 'blue-badge'
                      : 'orange-badge'
                  "
                  v-for="(item, index) in data.value"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </template>

            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <v-btn
                  @click="openReminderDialog(data.item)"
                  height="42"
                  class="blue-mainBtn"
                  >پیگیری</v-btn
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <v-row v-if="filteredLetters.length" class="mt-8">
            <v-col class="d-flex flex-row">
              <span class="pt-2">تعداد موارد نمایش در هر صفحه</span>
              <div class="blue-number-box ms-3 me-3">
                <v-select
                  outlined
                  v-model="perPage"
                  :items="perPageOptions"
                  @change="currentPage = 1"
                ></v-select>
              </div>
            </v-col>
            <v-col>
              <div
                class="d-flex flex-row justify-content-end blue-custom-pagination"
              >
                <v-btn @click="goToFirst()" class="navigation-btn"
                  ><v-icon>$ArrowDoubleRight</v-icon></v-btn
                >
                <v-pagination
                  v-model="currentPage"
                  :length="Math.ceil(filteredLetters.length / perPage)"
                  :total-visible="5"
                  prev-icon="$ArrowLeft"
                  next-icon="$ArrowRight"
                ></v-pagination>
                <v-btn @click="goToLast()" class="navigation-btn"
                  ><v-icon>$ArrowDoubleLeft</v-icon></v-btn
                >
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="reminderDialog" width="600">
      <v-card class="modal-card">
        <div class="d-flex flex-row custom-input">
          <v-text-field
            outlined
            dense
            height="40"
            v-model="selected.followingDate"
            id="letterDate"
          >
            <template slot="label">
              <div style="font-size: 14px">تاریخ پیگیری</div>
            </template>
          </v-text-field>
          <v-btn
            class="ms-2 blue-borderedBtn"
            id="letterDate"
            width="40"
            min-width="40"
            height="40"
            ><v-icon>$Calendar</v-icon></v-btn
          >
          <date-picker
            element="letterDate"
            v-model="selected.followingDate"
            color="#6092cd"
          ></date-picker>
        </div>
        <div class="custom-input my-4">
          <v-select
            outlined
            v-model="selected.followingStatus"
            :items="statusTypes"
            height="40"
            dense
            item-text="text"
            item-value="value"
          >
            <template slot="label">
              <div style="font-size: 14px">وضعیت</div>
            </template>
          </v-select>
        </div>
        <div class="custom-input">
          <v-textarea
            outlined
            dense
            label="توضیحات"
            v-model="selected.followingNote"
          ></v-textarea>
        </div>
        <div class="float-end mt-4">
          <v-btn class="blue-mainBtn" @click="submitStatus()"> ثبت</v-btn>
          <v-btn class="red-borderedBtn ms-2" @click="reminderDialog = false"
            >بازگشت</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      search: "",
      fields: [
        { key: "index", label: "#" },
        { key: "letterNo", label: "شماره نامه" },
        { key: "title", label: "موضوع نامه" },
        { key: "date", label: "تاریخ ارسال" },
        { key: "followingDate", label: "تاریخ پیگیری" },
        { key: "type", label: "نوع نامه" },
        { key: "operation", label: "عملیات" },
      ],
      letters: [],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      letterType: "all",
      typeOptions: [
        { value: "all", text: "همه" },
        { value: "inbox", text: "ورودی" },
        { value: "outbox", text: "خروجی" },
        { value: "internal", text: "سازمانی" },
      ],
      isLoaded: false,
      perPageOptions: [10, 15, 20],
      reminderDialog: false,
      selected: {},
      statusTypes: [
        { value: "pending", text: "در حال پیگیری" },
        { value: "done", text: "اتمام پیگیری" },
        { value: "canceled", text: "لغو پیگیری" },
      ],
      followingNote: "",
      followingStatus: "",
    };
  },
  methods: {
    goToFirst() {
      this.currentPage = 1;
    },
    goToLast() {
      this.currentPage = Math.ceil(this.letters.length / this.perPage);
    },
    getLetters() {
      Axios.post(
        this.baseUrl + "/ppkpms/secretariat/letters/followings",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.letters = res.data;
            this.isLoaded = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    submitStatus() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/secretariat/letter/manageFollowing",
        {
          letterId: this.selected.id,
          followingDate: this.selected.followingDate,
          followingNote: this.selected.followingNote,
          followingStatus: this.selected.followingStatus,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.toast("درخواست پیگیری به ثبت رسید.", "success");
          this.vLoading = false;
          this.reminderDialog = false;
          this.getLetters();
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.vLoading = false;
        });
    },
    openReminderDialog(item) {
      this.selected = item;
      this.reminderDialog = true;
      this.selected.followingStatus = "pending";
    },
  },
  computed: {
    filteredLetters() {
      if (this.isLoaded) {
        let filtered = [];
        filtered = this.letters;
        if (this.letterType != "all") {
          return filtered.filter(
            (x) =>
              x.typeEn == this.letterType && x.letterNo.includes(this.search)
          );
        } else {
          return filtered.filter((x) => x.letterNo.includes(this.search));
        }
      }
    },
  },
  mounted() {
    this.getLetters();
  },
};
</script>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.reminders {
  .letter-card {
    border-radius: 17px;
    padding: 30px 20px 20px 25px;
  }
}
</style>
